import { Pagination as PaginationComponent } from '@change/ds-core-ui';

import { usePaginationComponent } from './hooks/usePagination';

export const Pagination: React.FC = () => {
	const {
		data: { currentPage, totalPages, shouldHidePagination },
		actions: { setPage },
	} = usePaginationComponent();

	if (shouldHidePagination) {
		return null;
	}

	return (
		<div className="flex justify-center overflow-hidden py-10">
			<PaginationComponent currentPage={currentPage + 1} totalPages={totalPages} onPageChange={setPage} />
		</div>
	);
};
